import React from 'react';
import '../../www/assets/css/geology_map_legend.css';


export default function geolog_map_legend({legend}){

    return <div className='geo-legend'>
                    <p>{legend.title}</p>
                    <table className='leg-table' >
                        <tbody>
                        {legend.data &&  legend.data.map((l,i)=> 
                            <tr key={i}>
                                <td className='leg-td' style={{background: l.color ,padding: '0em 1em'}}></td>
                                <td className='leg-td' style={{paddingLeft:'0.5em'}}>{l.text}</td>
                            </tr>
                            
                            )
                        }
                        </tbody>
                    </table>
            </div>

}
